// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PtoArrArrowrIghtOutlinedSvg from "@fishx/icons-svg/es/asn/PtoArrArrowrIghtOutlined";
import FishxIcon from '../components/FishxIcon';

var PtoArrArrowrIghtOutlined = function PtoArrArrowrIghtOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PtoArrArrowrIghtOutlinedSvg
  }));
};

PtoArrArrowrIghtOutlined.displayName = 'PtoArrArrowrIghtOutlined';
export default React.forwardRef(PtoArrArrowrIghtOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PtoArrArrowrIghtOutlined.js
// module id = 3870
// module chunks = 0